import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useReducer,
} from "react";
import alertReducer, {
  ACTION_SET_ALERTS,
  alertInitialState,
} from "reducers/alert.reducer";
import AlertService from "services/Alert.service";
import { AuthContext } from "webContext/Auth.context";

export const AlertContext = createContext();

function sortAlerts(alerts) {
  return new Map(
    alerts
      .sort((a, b) => new Date(b.changeDatetime) - new Date(a.changeDatetime))
      .map((alert) => [alert.alertId, alert]),
  );
}

export const AlertProvider = ({ children }) => {
  const [userAlertsState, userAlertsDispatch] = useReducer(
    alertReducer,
    alertInitialState,
  );
  const [allAlertsState, allAlertsDispatch] = useReducer(
    alertReducer,
    alertInitialState,
  );

  const { isAdmin, isMessagingManager } = useContext(AuthContext);

  const getAlerts = useCallback(
    async (includeDeleted = false) => {
      const userAlertsRes = await AlertService.getAlerts();

      userAlertsDispatch({
        type: ACTION_SET_ALERTS,
        payload: userAlertsRes.payload,
      });

      if (isAdmin || isMessagingManager) {
        const allAlertsRes = await AlertService.getAllAlerts(includeDeleted);
        allAlertsDispatch({
          type: ACTION_SET_ALERTS,
          payload: allAlertsRes.payload,
        });
      }
    },
    [isAdmin, isMessagingManager],
  );

  const sortedUserAlerts = useMemo(
    () => sortAlerts(userAlertsState.alertList),
    [userAlertsState.alertList],
  );

  const sortedAllAlerts = useMemo(
    () => sortAlerts(allAlertsState.alertList),
    [allAlertsState.alertList],
  );

  return (
    <AlertContext.Provider
      value={{
        getAlerts,
        sortedAlerts: sortedUserAlerts,
        sortedAllAlerts,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
